<template>
    <el-dialog title="添加数据" :visible.sync="show" width="550px">
        <el-form ref="form" :model="form" :rules="formRules" label-position="right" label-width="120px">
            <el-form-item label="渠道" prop="source">
                <el-select style="width: 150px" class="filter-item" v-model="form.source">
                    <el-option v-for="item in importSources" :key="item.dataName" :label="item.dataDisplay"
                        :value="item.dataName"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="经销商" prop="dealerCode">
                <el-cascader class="filter-item" style="width: 350px" placeholder="选择经销商" filterable
                    :show-all-levels="false" :options="dealerOptions" v-model="form.dealerCode"></el-cascader>
            </el-form-item>
            <el-form-item label="姓名" prop="name">
                <el-input style="width: 200px" v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item label="电话" prop="phone">
                <el-input style="width: 200px" v-model="form.phone"></el-input>
            </el-form-item>
            <el-form-item label="车系" prop="seriesId">
                <el-select v-model="form.seriesId" filterable placeholder="请选择车系">
                    <el-option v-for="item in seriesOptions" :key="item.id" :label="item.name"
                        :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="订金(元)" prop="paymentMoney">
                <el-input-number style="width: 200px" v-model="form.paymentMoney" :precision="2" :step="1"
                    :max="10000"></el-input-number>
            </el-form-item>
            <el-form-item label="来源描述" prop="siteDesc">
                <el-input style="width: 350px" v-model="form.siteDesc"></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="show = false">取消</el-button>
            <el-button type="primary" @click="handleSubmit">确定</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { formRules, CONSTANT_0 } from '../js/form-options'
export default {
    name: 'add-clue',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        importSources: {
            type: Array,
            default: () => []
        },
        dealerOptions: {
            type: Array,
            default: () => []
        },
        seriesOptions: {
            type: Array,
            default: () => []
        },
    },
    watch: {
        visible(newVal) {
            this.show = newVal;
            this.$nextTick(() => {
                this.$refs["form"].resetFields()
            })
        },
        show(newVal) {
            this.$emit('update:visible', newVal);
        },
    },
    data() {
        return {
            formRules: Object.freeze(formRules),
            show: false,
            form: {
                source: "",
                dealerCode: [],
                seriesId: "",
                name: "",
                phone: "",
                siteDesc: "",
                paymentMoney: 0,
            },
        }
    },
    methods: {
        handleSubmit() {
            this.$refs["form"].validate((valid) => {
                if (valid) {
                    const { source, name, phone, seriesId, siteDesc, paymentMoney, dealerCode } = this.form
                    let dealerCodeParam = "";
                    if (dealerCode.length > CONSTANT_0) {
                        dealerCodeParam = dealerCode[dealerCode.length - 1];
                    }
                    this.$httpAuth
                        .post("/v1/backendClueRpc/add", {
                            source: source,
                            dealerCode: dealerCodeParam,
                            name: name,
                            phone: phone,
                            seriesId: seriesId,
                            siteDesc: siteDesc,
                            paymentMoney: paymentMoney * 100,
                        })
                        .then((response) => {
                            if ((response.data.code == 202 && response.data.status == -2) || (response.data.code == 1004 && response.data.status == -2)) {
                                this.$emit('blc', {
                                    name,
                                    mobile: phone,
                                    idNo: '',
                                    detail: response.data.detail,
                                });
                                return;
                            }
                            this.$emit('getList');
                            this.show = false
                        })
                        .catch(() => { });
                }
            });
        },
    }
}
</script>